import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import PanggilanPoli from "@/services/panggilan/PanggilanPoli";

@Module({ dynamic: true, namespaced: true, store, name: "panggilan-layanan" })
class PanggilanLayanan extends VuexModule {
  panggilanDokter = {};
  panggilanPerawat = {};
  panggilanPoli = [];
  allPanggilan = [];
  _loading = false;

  @Mutation
  SET_ALL_PANGGILAN(data) {
    this.allPanggilan = data;
  }

  @Mutation
  SET_LOADING(val) {
    this._loading = val;
  }

  @Action({ rawError: true })
  async getAllPanggilan(registerId): Promise<void> {
    this.SET_LOADING(true);

    const panggilanData = await PanggilanPoli.getStatusByRegister(
      registerId
    ).finally(() => {
      this.SET_LOADING(false);
    });

    // const response = suketArray.data.length ? suketArray[0] : null;
    this.SET_ALL_PANGGILAN(panggilanData);
  }

  @Mutation
  SET_PANGGILAN_DOKTER(data) {
    this.panggilanDokter = data;
  }

  @Action({ rawError: true })
  async getPanggilanDokter(unitId, dokterId) {
    const panggilan = this.allPanggilan.find(item => {
      return item.dr_id == dokterId && item.unitId == unitId;
    })

    this.SET_PANGGILAN_DOKTER(panggilan);
  }
}

export default getModule(PanggilanLayanan);
